import { createGenericSlice } from './genericSliceFactory';
import type { FAQ } from '@/types';

const faqSlice = createGenericSlice<FAQ>({
    name: 'faqs',
    endpoint: '/faqs',
});

export const {
    setCurrentItem: setCurrentFaq,
    clearError,
} = faqSlice.actions;

export const {
    fetchActive: fetchActiveFaqs,
} = faqSlice.thunks;

export default faqSlice.reducer;
